import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const messageImageModalSelector = createSelector(modalsSelector, (modals) => modals.messageImage);

export default messageImageModalSelector;
